import React from "react";
import Error from "./Error";

class ErrorBoundary extends React.Component {

    state = {error: null};

    render() {
        if (!this.state.error) return this.props.children;
        else return <Error/>;
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

}


export default ErrorBoundary;